import React from 'react';
import './hibuTextButton.scss';
import {IconType} from '../../icons/icons';
import {Button} from 'react-bootstrap';
import classNames from 'clsx';

type ButtonProps = {
    onClick?: () => void;
    disabled: boolean;
    label: string;
    icon?: IconType;
    filled?: boolean;
    type?: 'button' | 'submit' | 'reset';
    className?: string;
    form?: string;
}
export const HibuTextButton = React.memo(({
                                              label,
                                              icon,
                                              disabled = false,
                                              onClick,
                                              filled,
                                              type = 'button',
                                              className,
                                              form
                                          }: ButtonProps) => {

    const children = (): React.JSX.Element => {
        if (!icon) {
            return <>{label}</>;
        }
        const Icon = icon;
        return <><Icon/> {label} </>;
    };

    return (
        <Button
            className={classNames('hibu-text-button', type, disabled ? 'disabled' : '',
                filled ? 'filled' : '', className)}
            onClick={onClick} type={type} disabled={disabled} form={form}>
            {children()}
        </Button>
    );
});
